<template>
  <component
    :is="componentId"
    :column="column"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import DxCell from '@devexpress/dx-vue-grid';
import EditCell from './EditCell';
import DeleteCell from './DeleteCell';
import DisableCell from './DisableCell';
import TextCell from './TextCell';
import { DxGrid, DxTable } from '@devexpress/dx-vue-grid-bootstrap4';

export default {
  inheritAttrs: false,
  props: ['column'],
  computed: {

    componentId: function() {
      return this.column.cell || 'text-cell';
    },
  },
  components: {
    DxCell: DxTable.components.DxCell,
    EditCell,
    DeleteCell,
    DisableCell,
    TextCell,
  },
};
</script>
